import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { UndefinedDependencyError } from './errors';
import { DEFAULT_INJECTION_CONTEXT } from './injection-context';
import { ModuleRef } from './module-ref';
import { ProviderWrapper } from './provider-wrapper';
import { Reflector } from './reflection';
import { isDynamicModule } from './types';
import { runHooks } from './utils/hooks';
export var Module = /*#__PURE__*/function () {
  function Module(_name, _metadata, _Metatype) {
    _classCallCheck(this, Module);

    this._name = _name;
    this._metadata = _metadata;
    this._providers = new Map();
    this._imports = [];
    var providers = this._metadata.providers;
    var useModuleRefProvider = {
      provide: ModuleRef,
      useValue: new ModuleRef(this)
    };
    this._instance = _Metatype != null ? new _Metatype() : undefined;

    for (var _i = 0, _arr = [].concat(_toConsumableArray(providers), [useModuleRefProvider]); _i < _arr.length; _i++) {
      var provider = _arr[_i];
      var wrapper = new ProviderWrapper(this, provider);

      this._providers.set(wrapper.key, wrapper);
    }
  }

  _createClass(Module, [{
    key: "providers",
    get: function get() {
      return this._providers;
    }
  }, {
    key: "container",
    get: function get() {
      return this._container;
    },
    set: function set(container) {
      this._container = container;
    }
  }, {
    key: "imports",
    get: function get() {
      return this._imports;
    },
    set: function set(imports) {
      this._imports = imports;
    }
  }, {
    key: "exports",
    get: function get() {
      return this._metadata.exports;
    }
  }, {
    key: "name",
    get: function get() {
      return this._name;
    }
  }, {
    key: "createInstances",
    value: function () {
      var _createInstances = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _iterator, _step, _step$value, wrapper;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _iterator = _createForOfIteratorHelper(this._providers);
                _context.prev = 1;

                _iterator.s();

              case 3:
                if ((_step = _iterator.n()).done) {
                  _context.next = 9;
                  break;
                }

                _step$value = _slicedToArray(_step.value, 2), wrapper = _step$value[1];
                _context.next = 7;
                return wrapper.createInstance();

              case 7:
                _context.next = 3;
                break;

              case 9:
                _context.next = 14;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](1);

                _iterator.e(_context.t0);

              case 14:
                _context.prev = 14;

                _iterator.f();

                return _context.finish(14);

              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[1, 11, 14, 17]]);
      }));

      function createInstances() {
        return _createInstances.apply(this, arguments);
      }

      return createInstances;
    }()
  }, {
    key: "callOnInit",
    value: function () {
      var _callOnInit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _iterator2, _step2, _step2$value, provider;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return runHooks(this._instance, 'onModuleInit');

              case 2:
                _iterator2 = _createForOfIteratorHelper(this._providers);
                _context2.prev = 3;

                _iterator2.s();

              case 5:
                if ((_step2 = _iterator2.n()).done) {
                  _context2.next = 11;
                  break;
                }

                _step2$value = _slicedToArray(_step2.value, 2), provider = _step2$value[1];
                _context2.next = 9;
                return provider.callOnInit();

              case 9:
                _context2.next = 5;
                break;

              case 11:
                _context2.next = 16;
                break;

              case 13:
                _context2.prev = 13;
                _context2.t0 = _context2["catch"](3);

                _iterator2.e(_context2.t0);

              case 16:
                _context2.prev = 16;

                _iterator2.f();

                return _context2.finish(16);

              case 19:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[3, 13, 16, 19]]);
      }));

      function callOnInit() {
        return _callOnInit.apply(this, arguments);
      }

      return callOnInit;
    }()
  }, {
    key: "callOnDidInit",
    value: function () {
      var _callOnDidInit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var _iterator3, _step3, _step3$value, provider;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return runHooks(this._instance, 'onModuleDidInit');

              case 2:
                _iterator3 = _createForOfIteratorHelper(this._providers);
                _context3.prev = 3;

                _iterator3.s();

              case 5:
                if ((_step3 = _iterator3.n()).done) {
                  _context3.next = 11;
                  break;
                }

                _step3$value = _slicedToArray(_step3.value, 2), provider = _step3$value[1];
                _context3.next = 9;
                return provider.callOnDidInit();

              case 9:
                _context3.next = 5;
                break;

              case 11:
                _context3.next = 16;
                break;

              case 13:
                _context3.prev = 13;
                _context3.t0 = _context3["catch"](3);

                _iterator3.e(_context3.t0);

              case 16:
                _context3.prev = 16;

                _iterator3.f();

                return _context3.finish(16);

              case 19:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[3, 13, 16, 19]]);
      }));

      function callOnDidInit() {
        return _callOnDidInit.apply(this, arguments);
      }

      return callOnDidInit;
    }()
  }, {
    key: "resolveToken",
    value: function resolveToken(token) {
      var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_INJECTION_CONTEXT;
      var wrapper;

      if (this.providers.has(token)) {
        wrapper = this.providers.get(token);
      }

      if (wrapper == null) {
        wrapper = this._resolveFromImports(token, context);
      }

      if (wrapper == null) {
        var _this$_container;

        wrapper = (_this$_container = this._container) === null || _this$_container === void 0 ? void 0 : _this$_container.globalModule.providers.get(token);
      }

      if (wrapper == null) {
        var name = typeof token === 'function' ? token.name : token.toString();
        throw new UndefinedDependencyError(name, this.name);
      }

      return wrapper;
    }
  }, {
    key: "_resolveFromImports",
    value: function _resolveFromImports(token, context) {
      var visited = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
      var module = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : this;
      var imports = module.imports;

      var _iterator4 = _createForOfIteratorHelper(imports),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var importedModule = _step4.value;

          if (!visited.includes(importedModule)) {
            visited.push(importedModule);
            var exports = importedModule.exports,
                providers = importedModule.providers;

            if (exports.includes(token) && !providers.has(token)) {
              throw new Error('Exported provided not found. Make sure it is added to the providers array.');
            }

            if (exports.includes(token)) {
              return providers.get(token);
            } else {
              var wrapper = this._resolveFromImports(token, context, visited, importedModule);

              if (wrapper != null) return wrapper;
            }
          }
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
    }
  }], [{
    key: "getMetadata",
    value: function () {
      var _getMetadata = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(moduleDef) {
        var _providers$imports$ex, module, metadata, _metadata2;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return moduleDef;

              case 2:
                moduleDef = _context4.sent;

                if (!isDynamicModule(moduleDef)) {
                  _context4.next = 8;
                  break;
                }

                _providers$imports$ex = _objectSpread({
                  providers: [],
                  imports: [],
                  exports: []
                }, moduleDef), module = _providers$imports$ex.module, metadata = _objectWithoutProperties(_providers$imports$ex, ["module"]);
                return _context4.abrupt("return", _objectSpread(_objectSpread({}, metadata), {}, {
                  name: module.name
                }));

              case 8:
                _metadata2 = Reflector.getModuleMetadata(moduleDef);
                return _context4.abrupt("return", _objectSpread(_objectSpread({}, _metadata2), {}, {
                  name: moduleDef.name
                }));

              case 10:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function getMetadata(_x) {
        return _getMetadata.apply(this, arguments);
      }

      return getMetadata;
    }()
  }]);

  return Module;
}();